import React from "react";
import Modal from '../Modal'
import LoaderButton from "../../components/LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import SwitchStyle1 from "../useful/SwitchButton";


class PrintModal extends React.Component {
    state = {
        headers: [
            { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            { key: 'layout', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Layout', placeholder: '{{lang}}Landscape', required: true } },
            { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        options: [
            { title: "{{lang}}Add view name as title" },
            { title: "{{lang}}Include row Numbers" },
            { title: "{{lang}}Wrap long text into multiple lines" },
        ]
    }


    render() {
        let options = this.state.options
        return (

            <Modal maxWidth={350} height={"100%"} ref={el => this.modal = el}>
                <div className="w-100 br-10" style={{ backgroundColor: "white", overflow: 'hidden' }} >
                    <div className='p-3 position-sticky top-0' style={{ background: 'linear-gradient(90deg, #5856D6, #7D7AFF)', zIndex: 2, height: '50px' }}>
                        <p className="font-size-18 weight-500 white">{translate('Print Setting')}</p>
                    </div>
                    <div className="mt-3 px-2" style={{}}>
                        <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input4"} />
                    </div>
                    <div className="px-4">
                        {this.state.options.map((prop, index) => {
                            return (
                                <div className="flexcb w-100 py-2" key={index}>
                                    <p className="font-size-14 weight-300">{checkTranslation(prop.title)}</p>
                                    <div className="flexcc">
                                        <SwitchStyle1 id={index} color={'#4E4CCC'} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="mx-4 mt-4 br-15" style={{ backgroundColor: "#f6f6f6" }}>
                        <p className="p-3 font-size-12 weight-300">{translate('Create Completely custom print layouts with the')}<span className="text-link"> {translate('page builder')} </span>{translate('feture')}.</p>
                    </div>
                    <div className="p-4 w-100 d-flex" style={{ justifyContent: "flex-end" }}>
                        <button className="gray-btn px-3 py-2 br-5">
                            <p>{translate('Cancel')}</p>
                        </button>
                        <button className="px-4 py-2 br-5 mld-4 purple-btn">
                            <p className="white font-size-14">{translate('Print')}</p>
                        </button>
                    </div>
                </div>
            </Modal>
        );

    }
}


export default PrintModal;
